import React, { useState } from 'react'

const SurahCard = ({surah, date, tekrar}) => {
  const [updatedDate, setUpdatedDate] = useState(date);
  const [updatedTekrar, setUpdatedTekrar] = useState(tekrar);
  const [disabled, setDisabled] = useState(false);

    const handleUpdate = async () => {
        const date = new Date();
        const day = date.getDate();
        const month = date.getMonth() + 1;
        const year = date.getFullYear();
        const formattedDate = `${month}/${day}/${year}`;
        setUpdatedDate(formattedDate);
        setUpdatedTekrar((curr) => (parseInt(curr) + 1));
        setDisabled(true);
      
        try {
          const response = await fetch(
            process.env.REACT_APP_API_LINK,
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              mode: "no-cors",
              body: JSON.stringify({
                action: "update",
                surah: surah,
                last_date: formattedDate,
              }),
            }
          );
      
          setDisabled(false);
          let result = await response;
          
          if (result.error) {
            console.log(result);
            result = await result.json();
          } else {
            console.log(`Surah '${surah}' updated with last_date: ${formattedDate}`);
          }
      
          if (result.error) {
            throw new Error(result.error);
          }
  
        } catch (error) {
          console.log(`Error: ${error.message}`);
        }
      };
      
    //   const todays_date = new Date();
    //   const days_left = 
    const temp_date = new Date(updatedDate);
    const todays_date = new Date();
    const time_difference = temp_date - todays_date
    const days_difference = Math.floor(time_difference / (1000 * 3600 * 24)) +8;

  return (
    <div className="bg-white rounded-xl border p-4">
        <div className="px-1 py-4">
        <div className="font-bold text-5xl mb-6">{surah}</div>
        <h4 className="text-xl font-bold text-gray-900 mb-2">Days Left: {days_difference}</h4>
        <p className="text-gray-800 text-base">
            Last Recited: {updatedDate}
        </p>
        <p className="text-gray-800 text-base">
            {updatedTekrar < 41 ? `Tekrar Amount: ${updatedTekrar}` : 'Makhzoun'}
        </p>
        </div>
        <div className="px-1 py-1">
            <button
                className="middle none center mr-3 rounded-xl bg-gradient-to-tr from-pink-600 to-pink-400 py-2.5 px-10 font-sans text-xs font-bold uppercase text-white shadow-md shadow-pink-500/20 transition-all hover:shadow-lg hover:shadow-pink-500/40 active:opacity-[0.85] disabled:pointer-events-none disabled:opacity-50 disabled:shadow-none"
                data-ripple-light="true"
                onClick={handleUpdate}
                disabled={disabled}
            >
                <h4 className="text-lg">Update</h4>
            </button>
        </div>
    </div>
  )
}

export default SurahCard